import * as Backbone from 'backbone';
import * as _ from 'underscore';

import config from '../../common/config';

export var Model = Backbone.Model.extend({
    errors: [],
    constructor: function () {
        this.defaults = _.extend({}, this.defaults, {
            Calculation: {}
        });

        Backbone.Model.prototype.constructor.apply(this, arguments);
    },
    "sync": function (method, model, options) {
        if (method == 'read') {
            options.url =  config.webApiUrl() + '/api/publicRecaptcha/-1';
        } else if (method == 'create') {
            options.url =  config.webApiUrl() + '/api/publicRecaptcha/' + options.route + '/-1';
        } 
        return Backbone.sync(method, model, options);
    },
    initialize: function () {
        var that = this;
    },
    validateNoBackbone: function (attrs, app, callback) {
        this.errors = [];

        var self = this;

        var tmpModel = {};
        tmpModel.Method = 'GetEmailUsed';
        tmpModel.Value = attrs.Email;

        app.entities.collections.publicCustom2.fetch ({
            silens : true,
            wait : true,
            tmpModel: tmpModel,
            success: function (mode, response) {
                callbackInternal(false);
            },
            error : function (mode, response) {
                callbackInternal(true);
            },
        });

        var callbackInternal = function (error) {

            //Fields required
            if (error) {
                self.errors.push({ name: 'forgotPassword_inputEmail', message: resources.X100903 });
            }

            if (self.errors.length > 0) {
                callback(false);
            }
            else {
                callback(true);
            }
        }
    }
});

    